module.exports = __webpack_public_path__ + "assets/img/36_1440_big.eac9e972.jpg";